import { useQuery } from 'react-query';
import Patients from '../../services/Patients';
import { NEXT_APPOINTMENT } from '../../constants/reactQuery.keys';

export function useNextAppointment(patientId: number) {
  return useQuery([NEXT_APPOINTMENT, patientId], () => Patients.getNextAppointment(patientId));
}
